/**
 * AURUM Finance — PPN Simulator
 * Monthly savings calculator for gold investment program
 * Includes chart/table visualization
 * Gold price fetched from live API
 */
(function () {
  var AURUM_API = 'https://aurum-api.vercel.app';
  var chartInstance = null;

  function simCalc() {
    var amount = parseFloat(document.getElementById('simAmount').value) || 20;
    var duration = parseInt(document.getElementById('simDuration').value, 10) || 120;
    var goldPrice = parseFloat(document.getElementById('simGoldPrice').value);
    var growth = parseFloat(document.getElementById('simGrowth').value) || 5;

    if (!goldPrice || goldPrice <= 0) return; // Don't calculate without real price

    var totalInvest = amount * duration;
    var monthlyRate = growth / 100 / 12;

    // Compound interest: yearly snapshots for chart/table
    var yearlyData = [];
    var years = Math.ceil(duration / 12);

    for (var y = 1; y <= years; y++) {
      var monthsElapsed = Math.min(y * 12, duration);
      var invested = amount * monthsElapsed;
      var total = 0;
      for (var m = 0; m < monthsElapsed; m++) {
        total = total * (1 + monthlyRate) + amount;
      }
      var endPriceY = goldPrice * Math.pow(1 + growth / 100, y);
      yearlyData.push({
        year: y,
        invested: invested,
        grams: total / endPriceY,
        goldPrice: endPriceY,
        value: total
      });
    }

    // Final values
    var endValue = yearlyData.length ? yearlyData[yearlyData.length - 1].value : 0;
    var totalGrams = yearlyData.length ? yearlyData[yearlyData.length - 1].grams : 0;
    var endPrice = goldPrice * Math.pow(1 + growth / 100, duration / 12);

    // Renta using annuity formula
    var rentaDuration = 120;
    var renta;
    if (monthlyRate > 0) {
      renta = endValue * (monthlyRate / (1 - Math.pow(1 + monthlyRate, -rentaDuration)));
    } else {
      renta = endValue / rentaDuration;
    }

    var fmt = function (n) {
      return Math.round(n).toLocaleString('sk-SK');
    };

    var el = function (id) { return document.getElementById(id); };

    if (el('simTotalInvest')) el('simTotalInvest').textContent = fmt(totalInvest) + ' \u20ac';
    if (el('simTotalGrams')) el('simTotalGrams').textContent = totalGrams.toFixed(2) + ' g';
    if (el('simTotalOz')) el('simTotalOz').textContent = '\u2248 ' + (totalGrams / 31.1035).toFixed(2) + ' tr\u00f3jskej unce';
    if (el('simEndValue')) el('simEndValue').textContent = fmt(endValue) + ' \u20ac';
    if (el('simEndNote')) el('simEndNote').textContent = 'pri predpokladanej cene ' + endPrice.toFixed(0) + ' \u20ac/g na konci programu';
    if (el('simRenta')) el('simRenta').textContent = fmt(renta) + ' \u20ac / mesiac';

    // Update chart
    updateChart(yearlyData);

    // Update table
    updateTable(yearlyData, fmt);
  }

  function updateChart(data) {
    var canvas = document.getElementById('simChart');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var wrap = canvas.parentElement;
    var w = wrap.offsetWidth;
    var h = wrap.offsetHeight || 250;
    canvas.width = w * 2;
    canvas.height = h * 2;
    ctx.scale(2, 2);

    ctx.clearRect(0, 0, w, h);

    if (!data.length) return;

    var pad = { top: 20, right: 20, bottom: 30, left: 60 };
    var cw = w - pad.left - pad.right;
    var ch = h - pad.top - pad.bottom;

    var maxVal = 0;
    for (var i = 0; i < data.length; i++) {
      if (data[i].value > maxVal) maxVal = data[i].value;
      if (data[i].invested > maxVal) maxVal = data[i].invested;
    }
    maxVal = maxVal * 1.1;

    var xStep = cw / (data.length - 1 || 1);

    // Grid lines
    ctx.strokeStyle = 'rgba(34,34,34,0.8)';
    ctx.lineWidth = 0.5;
    for (var g = 0; g <= 4; g++) {
      var gy = pad.top + ch - (ch * g / 4);
      ctx.beginPath();
      ctx.moveTo(pad.left, gy);
      ctx.lineTo(pad.left + cw, gy);
      ctx.stroke();

      ctx.fillStyle = '#666054';
      ctx.font = '10px Outfit, sans-serif';
      ctx.textAlign = 'right';
      ctx.fillText(Math.round(maxVal * g / 4).toLocaleString('sk-SK') + ' \u20ac', pad.left - 8, gy + 4);
    }

    // X labels
    ctx.fillStyle = '#666054';
    ctx.textAlign = 'center';
    ctx.font = '10px Outfit, sans-serif';
    for (var k = 0; k < data.length; k++) {
      var lx = pad.left + k * xStep;
      ctx.fillText(data[k].year + 'r', lx, h - 5);
    }

    // Draw invested line (green)
    ctx.strokeStyle = '#2dd4a8';
    ctx.lineWidth = 2;
    ctx.beginPath();
    for (var a = 0; a < data.length; a++) {
      var ax = pad.left + a * xStep;
      var ay = pad.top + ch - (data[a].invested / maxVal * ch);
      if (a === 0) ctx.moveTo(ax, ay); else ctx.lineTo(ax, ay);
    }
    ctx.stroke();

    // Draw value line (gold)
    ctx.strokeStyle = '#C9A84C';
    ctx.lineWidth = 2;
    ctx.beginPath();
    for (var b = 0; b < data.length; b++) {
      var bx = pad.left + b * xStep;
      var by = pad.top + ch - (data[b].value / maxVal * ch);
      if (b === 0) ctx.moveTo(bx, by); else ctx.lineTo(bx, by);
    }
    ctx.stroke();

    // Fill area under gold line
    ctx.fillStyle = 'rgba(201,168,76,0.08)';
    ctx.beginPath();
    ctx.moveTo(pad.left, pad.top + ch);
    for (var c = 0; c < data.length; c++) {
      var cx2 = pad.left + c * xStep;
      var cy2 = pad.top + ch - (data[c].value / maxVal * ch);
      ctx.lineTo(cx2, cy2);
    }
    ctx.lineTo(pad.left + (data.length - 1) * xStep, pad.top + ch);
    ctx.closePath();
    ctx.fill();
  }

  function updateTable(data, fmt) {
    var tbody = document.getElementById('simTableBody');
    if (!tbody) return;

    var html = '';
    for (var i = 0; i < data.length; i++) {
      var d = data[i];
      html += '<tr>';
      html += '<td>' + d.year + '</td>';
      html += '<td>' + fmt(d.invested) + ' \u20ac</td>';
      html += '<td>' + d.grams.toFixed(2) + ' g</td>';
      html += '<td>' + d.goldPrice.toFixed(0) + ' \u20ac</td>';
      html += '<td>' + fmt(d.value) + ' \u20ac</td>';
      html += '</tr>';
    }
    tbody.innerHTML = html;
  }

  function simChartSwitch(tab) {
    var panels = document.querySelectorAll('.sim-chart-panel');
    var tabs = document.querySelectorAll('.sim-chart-tab');

    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.remove('active');
    }
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].classList.remove('active');
    }

    if (tab === 'graf') {
      var grafPanel = document.getElementById('simPanelGraf');
      if (grafPanel) grafPanel.classList.add('active');
      if (tabs[0]) tabs[0].classList.add('active');
    } else {
      var tabulkaPanel = document.getElementById('simPanelTabulka');
      if (tabulkaPanel) tabulkaPanel.classList.add('active');
      if (tabs[1]) tabs[1].classList.add('active');
    }
  }

  // Set gold price on both panels from API value
  function setGoldPrice(price) {
    price = Math.round(price * 100) / 100;

    // Klasické panel
    var simPrice = document.getElementById('simGoldPrice');
    var simDisplay = document.getElementById('simGoldPriceDisplay');
    if (simPrice) simPrice.value = price;
    if (simDisplay) simDisplay.textContent = price + ' \u20ac/g';
    var simHint = document.getElementById('simGoldPriceHint');
    if (simHint) simHint.textContent = price + ' \u20ac/g';

    // Renta panel
    var rentaPrice = document.getElementById('rentaGoldPrice');
    var rentaPriceVal = document.getElementById('rentaGoldPriceVal');
    if (rentaPrice) rentaPrice.value = price;
    if (rentaPriceVal) rentaPriceVal.value = price;

    // Run calculations
    simCalc();
    if (typeof window.rentaCalc === 'function') window.rentaCalc();
  }

  // Fetch live gold price from API
  function fetchGoldPrice() {
    fetch(AURUM_API + '/api/gold-price')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        console.log('Gold price API response:', data);
        var price = data.price || data.pricePerGram || data.gold_price;
        if (price && price > 0) {
          setGoldPrice(price);
        } else {
          showGoldPriceError();
        }
      })
      .catch(function (err) {
        console.error('Failed to fetch gold price:', err);
        showGoldPriceError();
      });
  }

  function showGoldPriceError() {
    var display = document.getElementById('simGoldPriceDisplay');
    if (display) display.textContent = 'Cena nedostupná';
  }

  // Attach to inputs
  ['simAmount', 'simGoldPrice'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', simCalc);
  });

  ['simDuration', 'simGrowth'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('change', simCalc);
  });

  // Use metafield price if already set, otherwise try API
  var initialPrice = parseFloat(document.getElementById('simGoldPrice').value);
  if (initialPrice > 0) {
    setGoldPrice(initialPrice);
  } else {
    fetchGoldPrice();
  }

  // Expose globally for inline handlers
  window.simCalc = simCalc;
  window.simChartSwitch = simChartSwitch;
})();

/**
 * ═══════════════════════════════════════
 * PPN SIMULATOR — CHECKOUT FLOW
 * Step navigation, customer data, checkout
 * ═══════════════════════════════════════
 */
(function () {
  var AURUM_API_BASE = 'https://aurum-api.vercel.app';
  var ppnCustomerLoggedIn = false;
  var ppnCustomerEmail = '';
  var ppnOriginalCustomerData = null;

  // Detect logged-in customer
  var emailEl = document.getElementById('ppn-customer-email');
  if (emailEl && emailEl.value) {
    ppnCustomerLoggedIn = true;
    ppnCustomerEmail = emailEl.value;
  }

  // ── Step Navigation ──

  function ppnGoToStep(step) {
    var step1 = document.getElementById('ppn-step-1');
    var step2 = document.getElementById('ppn-step-2');
    var step3 = document.getElementById('ppn-step-3');
    var s1 = document.getElementById('ppn-stepper-1');
    var s2 = document.getElementById('ppn-stepper-2');
    var s3 = document.getElementById('ppn-stepper-3');

    // Hide all steps first
    if (step1) step1.style.display = 'none';
    if (step2) step2.style.display = 'none';
    if (step3) step3.style.display = 'none';

    // Also force-hide both calc panels when leaving step 1
    if (step !== 1) {
      var panelK = document.getElementById('panelKlasicke');
      var panelR = document.getElementById('panelRenta');
      if (panelK) panelK.style.display = 'none';
      if (panelR) panelR.style.display = 'none';
    } else {
      // Restore panel visibility when returning to step 1
      var panelK = document.getElementById('panelKlasicke');
      var panelR = document.getElementById('panelRenta');
      if (panelK) panelK.style.display = '';
      if (panelR) panelR.style.display = '';
    }

    // Show the target step
    if (step === 1 && step1) step1.style.display = 'block';
    if (step === 2 && step2) step2.style.display = 'block';
    if (step === 3 && step3) step3.style.display = 'block';

    if (s1) s1.classList.toggle('dv-step-active', step === 1);
    if (s2) s2.classList.toggle('dv-step-active', step === 2);
    if (s3) s3.classList.toggle('dv-step-active', step === 3);

    // Scroll to the target step
    var scrollTarget = (step === 3 && step3) ? step3 : (step === 2 && step2) ? step2 : document.querySelector('.ppn-sim');
    if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── "Chcem začať sporiť" button ──

  window.ppnStartSaving = function () {
    // Check if total investment exceeds 10,000€ — AML questionnaire required
    var amlAmount = parseFloat((document.getElementById('simAmount') || {}).value) || 20;
    var amlDuration = parseInt((document.getElementById('simDuration') || {}).value, 10) || 120;
    var amlTotal = amlAmount * amlDuration;

    var amlLimit = window.amlThreshold || 10000;
    var amlUrl = window.amlQuestionnaireUrl || '/pages/dotaznik';

    if (amlTotal >= amlLimit) {
      if (ppnCustomerLoggedIn) {
        window.location.href = amlUrl;
      } else {
        sessionStorage.setItem('ppnPendingAml', 'true');
        var rentaPanelAml = document.getElementById('panelRenta');
        sessionStorage.setItem('ppnCalcMode', (rentaPanelAml && rentaPanelAml.classList.contains('active')) ? 'renta' : 'klasicke');
        ppnGoToStep(2);
      }
      return;
    }

    // Detect current calc mode
    var rentaPanel = document.getElementById('panelRenta');
    var currentMode = (rentaPanel && rentaPanel.classList.contains('active')) ? 'renta' : 'klasicke';

    if (ppnCustomerLoggedIn) {
      ppnGoToStep(3);
      ppnProceedToStep3();
    } else {
      // Save flag and calc mode so we auto-proceed after login redirect
      sessionStorage.setItem('ppnPendingCheckout', 'true');
      sessionStorage.setItem('ppnCalcMode', currentMode);
      ppnGoToStep(2);
    }
  };

  // Auto-redirect to AML questionnaire if returning from login with pending AML
  if (ppnCustomerLoggedIn && sessionStorage.getItem('ppnPendingAml') === 'true') {
    sessionStorage.removeItem('ppnPendingAml');
    window.location.href = window.amlQuestionnaireUrl || '/pages/dotaznik';
  }

  // Auto-proceed to Step 3 if returning from login
  if (ppnCustomerLoggedIn && sessionStorage.getItem('ppnPendingCheckout') === 'true') {
    sessionStorage.removeItem('ppnPendingCheckout');
    // Restore calc mode before proceeding
    var savedMode = sessionStorage.getItem('ppnCalcMode') || 'klasicke';
    sessionStorage.removeItem('ppnCalcMode');
    if (typeof switchCalcMode === 'function') switchCalcMode(savedMode);
    ppnGoToStep(3);
    ppnProceedToStep3();
  }

  window.ppnBackToStep1 = function () {
    ppnGoToStep(1);
  };

  // ── Step 3: Populate Summary + Fetch Customer Data ──

  async function ppnProceedToStep3() {
    var isRenta = false;
    var rentaPanel = document.getElementById('panelRenta');
    if (rentaPanel && rentaPanel.classList.contains('active')) isRenta = true;

    var summaryRegular = document.getElementById('ppn-summary-regular');
    var summaryDuration = document.getElementById('ppn-summary-duration');
    var summaryExtra = document.getElementById('ppn-summary-extra');
    var summaryValue = document.getElementById('ppn-summary-value');

    if (isRenta) {
      var monthly = document.getElementById('rentaMonthlyVal');
      var investYears = document.getElementById('rentaYearsInvestVal');
      var payoutYears = document.getElementById('rentaYearsPayoutVal');
      var payout = document.getElementById('rentaResultAmount');

      if (summaryRegular) {
        summaryRegular.previousElementSibling.textContent = 'Mesačná investícia:';
        summaryRegular.textContent = (monthly ? parseInt(monthly.value) : 100).toLocaleString('sk-SK') + ' EUR';
      }
      if (summaryDuration) {
        summaryDuration.previousElementSibling.textContent = 'Roky investovania:';
        summaryDuration.textContent = (investYears ? investYears.value : '10') + ' rokov';
      }
      if (summaryExtra) {
        summaryExtra.previousElementSibling.textContent = 'Roky výplaty:';
        summaryExtra.textContent = (payoutYears ? payoutYears.value : '10') + ' rokov';
      }
      if (summaryValue) {
        summaryValue.previousElementSibling.textContent = 'Mesačná výplata:';
        summaryValue.textContent = payout ? payout.textContent : '0 EUR';
      }
    } else {
      var amount = document.getElementById('simAmount');
      var duration = document.getElementById('simDuration');
      var endValue = document.getElementById('simEndValue');

      if (summaryRegular) {
        summaryRegular.previousElementSibling.textContent = 'Výška pravidelnej platby:';
        summaryRegular.textContent = (amount ? parseInt(amount.value) : 20).toLocaleString('sk-SK') + ' EUR';
      }
      if (summaryDuration) {
        summaryDuration.previousElementSibling.textContent = 'Doba sporenia:';
        summaryDuration.textContent = Math.ceil(parseInt(duration ? duration.value : '120') / 12) + ' rokov';
      }
      if (summaryExtra) {
        summaryExtra.previousElementSibling.textContent = 'Výška mimoriadnej platby:';
        summaryExtra.textContent = '0 EUR';
      }
      if (summaryValue) {
        summaryValue.previousElementSibling.textContent = 'Predpokladaná hodnota sporenia:';
        summaryValue.textContent = endValue ? endValue.textContent : '0 €';
      }
    }

    // Fetch customer data from database
    var customerData = null;
    var isComplete = false;

    if (ppnCustomerEmail) {
      try {
        var response = await fetch(AURUM_API_BASE + '/api/customer-data?email=' + encodeURIComponent(ppnCustomerEmail));
        if (response.ok) {
          var dbData = await response.json();
          if (dbData && dbData.customerData) {
            customerData = dbData.customerData;
          } else if (dbData && dbData.success && dbData.data && dbData.data.first_name) {
            customerData = dbData.data;
          }
        }
      } catch (err) {
        console.error('Error fetching customer data:', err);
      }
    }

    if (customerData) {
      sessionStorage.setItem('ppnCustomerData', JSON.stringify(customerData));
      isComplete = ppnIsDataComplete(customerData);
    }

    ppnOriginalCustomerData = customerData || {};
    ppnOriginalCustomerData.email = ppnCustomerEmail;

    ppnRenderCustomerForm(ppnOriginalCustomerData, isComplete);
    ppnUpdateCheckoutButton(isComplete);
  }

  // ── Data Completeness Check ──

  function ppnIsDataComplete(data) {
    if (!data) return false;
    var required = ['first_name', 'last_name', 'phone', 'korespondencna_adresa'];
    for (var i = 0; i < required.length; i++) {
      var val = data[required[i]];
      if (!val || (typeof val === 'string' && val.trim() === '')) return false;
    }
    return true;
  }

  function ppnUpdateCheckoutButton(isComplete) {
    var btn = document.getElementById('ppn-checkout-btn');
    if (!btn) return;
    btn.disabled = !isComplete;
    btn.style.opacity = isComplete ? '1' : '0.5';
    btn.style.cursor = isComplete ? 'pointer' : 'not-allowed';
  }

  // ── Customer Form Rendering ──

  function ppnRenderCustomerForm(data, isComplete) {
    var container = document.getElementById('ppn-customer-form-container');
    if (!container) return;
    data = data || {};

    function esc(str) { return (str || '').replace(/"/g, '&quot;'); }

    function inp(id, label, val, type, required) {
      type = type || 'text';
      var req = required ? ' <span style="color:#C9A84C;">*</span>' : '';
      return '<div class="dv-customer-form-group">' +
        '<label for="ppn-' + id + '">' + label + req + '</label>' +
        '<input type="' + type + '" id="ppn-' + id + '" class="dv-summary-input" value="' + esc(val) + '"' +
        (type === 'email' ? ' disabled' : '') + '>' +
        '</div>';
    }

    var months = ['Január','Február','Marec','Apríl','Máj','Jún','Júl','August','September','Október','November','December'];
    var countries = [
      { v: 'SK', l: 'Slovensko' }, { v: 'CZ', l: 'Česko' }, { v: 'HU', l: 'Maďarsko' },
      { v: 'PL', l: 'Poľsko' }, { v: 'AT', l: 'Rakúsko' }, { v: 'DE', l: 'Nemecko' }
    ];

    var html = '<div class="dv-customer-form">';

    // Row 1: Name
    html += '<div class="dv-customer-form-row">';
    html += inp('first_name', 'Meno', data.first_name, 'text', true);
    html += inp('last_name', 'Priezvisko', data.last_name, 'text', true);
    html += '</div>';

    // Row 2: Email + Phone
    html += '<div class="dv-customer-form-row">';
    html += inp('email', 'Email', ppnCustomerEmail, 'email', false);
    html += inp('phone', 'Telefón', data.phone, 'tel', true);
    html += '</div>';

    // Row 3: Birth date
    html += '<div class="dv-customer-form-row">';
    var birthVal = '';
    if (data.birth_year && data.birth_month && data.birth_day) {
      birthVal = data.birth_year + '-' + String(data.birth_month).padStart(2, '0') + '-' + String(data.birth_day).padStart(2, '0');
    }
    html += '<div class="dv-customer-form-group"><label for="ppn-birthdate">Dátum narodenia</label>';
    html += '<input type="date" id="ppn-birthdate" class="dv-summary-input" value="' + birthVal + '">';
    html += '</div>';
    html += '</div>';

    // Row 4: Gender + Address
    html += '<div class="dv-customer-form-row">';
    html += '<div class="dv-customer-form-group"><label>Pohlavie</label>';
    html += '<div class="dv-customer-form-radio-group">';
    html += '<label><input type="radio" name="ppn-gender" id="ppn-gender-male" value="male"' + (data.gender === 'male' ? ' checked' : '') + '> Muž</label>';
    html += '<label><input type="radio" name="ppn-gender" id="ppn-gender-female" value="female"' + (data.gender === 'female' ? ' checked' : '') + '> Žena</label>';
    html += '</div></div>';
    html += inp('address', 'Adresa trvalého bydliska', data.address);
    html += '</div>';

    // Row 5: City + ZIP + Country
    html += '<div class="dv-customer-form-row">';
    html += inp('city', 'Mesto', data.city);
    html += inp('zip', 'PSČ', data.zip);
    html += '<div class="dv-customer-form-group"><label for="ppn-country">Krajina</label>';
    html += '<select id="ppn-country" class="dv-summary-input"><option value="">—</option>';
    for (var c = 0; c < countries.length; c++) {
      html += '<option value="' + countries[c].v + '"' + (data.country === countries[c].v ? ' selected' : '') + '>' + countries[c].l + '</option>';
    }
    html += '</select></div>';
    html += '</div>';

    // Correspondence address
    html += '<div class="dv-customer-form-row">';
    html += inp('korespondencna_adresa', 'Korešpondenčná adresa', data.korespondencna_adresa, 'text', true);
    html += '</div>';

    // Marketing consent
    html += '<div class="dv-customer-form-row">';
    html += '<div class="dv-customer-form-group">';
    html += '<label class="dv-customer-form-checkbox">';
    html += '<input type="checkbox" id="ppn-accepts_marketing"' + (data.accepts_marketing ? ' checked' : '') + '>';
    var _gdprUrl = window.gdprUrl || '/pages/ochrana-osobnych-udajov';
    var _vopUrl = window.vopUrl || '/pages/vseobecne-obchodne-podmienky';
    html += '<span>Súhlasím so spracovaním <a href="' + _gdprUrl + '" class="legal-link" target="_blank">osobných údajov</a> a <a href="' + _vopUrl + '" class="legal-link" target="_blank">obchodnými podmienkami</a></span>';
    html += '</label></div></div>';

    // Save button
    html += '<div style="display:flex;justify-content:flex-end;margin-top:8px;">';
    html += '<button type="button" id="ppn-save-changes" class="dv-btn dv-btn-primary" onclick="ppnSaveChanges()">Uložiť zmeny</button>';
    html += '</div>';

    html += '</div>';
    container.innerHTML = html;
  }

  // ── Save Customer Data ──

  window.ppnSaveChanges = async function () {
    var btn = document.getElementById('ppn-save-changes');
    if (!btn) return;
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ukladám...';

    try {
      var updatedData = {};
      for (var key in ppnOriginalCustomerData) {
        if (ppnOriginalCustomerData.hasOwnProperty(key)) updatedData[key] = ppnOriginalCustomerData[key];
      }

      var fields = ['first_name', 'last_name', 'phone', 'address', 'city', 'zip', 'country', 'korespondencna_adresa'];
      var hasChanges = false;

      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        var el = document.getElementById('ppn-' + f);
        if (el) {
          var newVal = (el.tagName === 'SELECT') ? el.value : el.value.trim();
          var oldVal = (ppnOriginalCustomerData[f] || '').toString();
          if (newVal !== oldVal) {
            updatedData[f] = newVal;
            hasChanges = true;
          }
        }
      }

      // Birthdate (single date input → split into day/month/year)
      var birthdateEl = document.getElementById('ppn-birthdate');
      if (birthdateEl && birthdateEl.value) {
        var parts = birthdateEl.value.split('-');
        var newYear = parts[0], newMonth = parseInt(parts[1], 10).toString(), newDay = parseInt(parts[2], 10).toString();
        if (newDay !== (ppnOriginalCustomerData.birth_day || '').toString() ||
            newMonth !== (ppnOriginalCustomerData.birth_month || '').toString() ||
            newYear !== (ppnOriginalCustomerData.birth_year || '').toString()) {
          updatedData.birth_day = newDay;
          updatedData.birth_month = newMonth;
          updatedData.birth_year = newYear;
          hasChanges = true;
        }
      }

      // Gender
      var maleR = document.getElementById('ppn-gender-male');
      var femaleR = document.getElementById('ppn-gender-female');
      var genderVal = '';
      if (maleR && maleR.checked) genderVal = 'male';
      else if (femaleR && femaleR.checked) genderVal = 'female';
      if (genderVal !== (ppnOriginalCustomerData.gender || '')) {
        updatedData.gender = genderVal;
        hasChanges = true;
      }

      // Marketing
      var mktgEl = document.getElementById('ppn-accepts_marketing');
      if (mktgEl) {
        var newMktg = mktgEl.checked;
        if (newMktg !== (ppnOriginalCustomerData.accepts_marketing || false)) {
          updatedData.accepts_marketing = newMktg;
          hasChanges = true;
        }
      }

      if (!hasChanges) {
        alert('Neboli vykonané žiadne zmeny.');
        btn.disabled = false;
        btn.textContent = origText;
        return;
      }

      // Validate required
      var required = ['first_name', 'last_name', 'phone', 'korespondencna_adresa'];
      for (var r = 0; r < required.length; r++) {
        var v = updatedData[required[r]];
        if (!v || (typeof v === 'string' && v.trim() === '')) {
          alert('Prosím vyplňte všetky povinné polia.');
          btn.disabled = false;
          btn.textContent = origText;
          return;
        }
      }

      updatedData.email = ppnCustomerEmail;

      // Save to database
      var payload = {
        customerId: ppnCustomerEmail,
        email: ppnCustomerEmail,
        calculatorData: {},
        customerData: updatedData
      };

      var response = await fetch(AURUM_API_BASE + '/api/customer-data', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Ukladanie zlyhalo');

      var result = await response.json();
      if (result.id) sessionStorage.setItem('databaseRecordId', result.id);

      // Re-fetch to verify
      var refreshRes = await fetch(AURUM_API_BASE + '/api/customer-data?email=' + encodeURIComponent(ppnCustomerEmail));
      var refreshData = null;
      if (refreshRes.ok) {
        var parsed = await refreshRes.json();
        if (parsed && parsed.customerData) refreshData = parsed.customerData;
        else if (parsed && parsed.data && parsed.data.first_name) refreshData = parsed.data;
      }

      if (refreshData) {
        ppnOriginalCustomerData = refreshData;
        ppnOriginalCustomerData.email = ppnCustomerEmail;
        sessionStorage.setItem('ppnCustomerData', JSON.stringify(refreshData));
      } else {
        ppnOriginalCustomerData = updatedData;
      }

      var isComplete = ppnIsDataComplete(ppnOriginalCustomerData);
      ppnRenderCustomerForm(ppnOriginalCustomerData, isComplete);
      ppnUpdateCheckoutButton(isComplete);

      alert('Údaje boli úspešne uložené!');
    } catch (err) {
      console.error('Error saving:', err);
      alert('Chyba pri ukladaní: ' + err.message);
    }

    btn.disabled = false;
    btn.textContent = origText;
  };

  // ── Checkout: Add to Cart & Redirect ──

  window.ppnCreateAndCheckout = async function () {
    if (!ppnCustomerLoggedIn) {
      alert('Prosím, najprv sa prihláste.');
      return;
    }

    var btn = document.getElementById('ppn-checkout-btn');
    if (!btn) return;

    var btnText = btn.querySelector('.button-text');
    var loadText = btn.querySelector('.loading-text');
    if (btnText) btnText.classList.add('hidden');
    if (loadText) loadText.classList.remove('hidden');
    btn.disabled = true;

    try {
      var goldPrice = parseFloat(document.getElementById('simGoldPrice').value) || 0;
      var databaseRecordId = sessionStorage.getItem('databaseRecordId') || '';

      var isRenta = false;
      var rentaPanel = document.getElementById('panelRenta');
      if (rentaPanel && rentaPanel.classList.contains('active')) isRenta = true;

      var regular;
      var itemProps = {
        '_appstle_subscription_plan': '1permonth',
        '_appstle_subscription_interval': 'month',
        '_appstle_subscription_interval_count': 1,
        'Aktualna cena zlata': goldPrice.toString(),
        'Database Record ID': databaseRecordId || 'N/A'
      };

      if (isRenta) {
        regular = parseInt(document.getElementById('rentaMonthlyVal').value) || 100;
        itemProps['Typ sporenia'] = 'Renta sporenie';
        itemProps['Mesačná investícia'] = regular.toString();
        itemProps['Roky investovania'] = (document.getElementById('rentaYearsInvestVal').value || '10');
        itemProps['Roky výplaty'] = (document.getElementById('rentaYearsPayoutVal').value || '10');
        itemProps['Mesačná výplata'] = (document.getElementById('rentaResultAmount').textContent || '0');
      } else {
        regular = parseInt(document.getElementById('simAmount').value) || 20;
        var duration = parseInt(document.getElementById('simDuration').value) || 120;
        itemProps['Typ sporenia'] = 'Predplatné';
        itemProps['Mesačná platba'] = regular.toString();
        itemProps['Mimriadna platba'] = '0';
        itemProps['Doba trvania'] = Math.ceil(duration / 12) + ' rokov';
      }

      // Find matching product variant
      if (typeof window.PPN_PRODUCT_VARIANTS === 'undefined' || !window.PPN_PRODUCT_VARIANTS.length) {
        throw new Error('Varianty produktu nie sú dostupné.');
      }

      var regularVariant = null;
      for (var i = 0; i < window.PPN_PRODUCT_VARIANTS.length; i++) {
        if (window.PPN_PRODUCT_VARIANTS[i].value === regular) {
          regularVariant = window.PPN_PRODUCT_VARIANTS[i];
          break;
        }
      }

      // Fallback: find closest variant
      if (!regularVariant) {
        var closest = window.PPN_PRODUCT_VARIANTS[0];
        for (var j = 1; j < window.PPN_PRODUCT_VARIANTS.length; j++) {
          if (Math.abs(window.PPN_PRODUCT_VARIANTS[j].value - regular) < Math.abs(closest.value - regular)) {
            closest = window.PPN_PRODUCT_VARIANTS[j];
          }
        }
        regularVariant = closest;
      }

      if (!regularVariant) throw new Error('Nepodarilo sa nájsť variantu produktu.');

      // Clear cart
      await fetch('/cart/clear.js', { method: 'POST' });

      // Add to cart with subscription
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: regularVariant.id,
            quantity: 1,
            selling_plan: 690478580053,
            properties: itemProps
          }]
        })
      });

      // Store checkout data
      sessionStorage.setItem('checkoutData', JSON.stringify({
        database_record_id: databaseRecordId,
        gold_price_at_order: goldPrice,
        regular_payment: regular,
        renta_mode: isRenta,
        timestamp: new Date().toISOString()
      }));

      // Redirect to checkout
      window.location.href = '/checkout';

    } catch (err) {
      console.error('Checkout error:', err);
      alert(err.message || 'Chyba pri vytváraní sporenia.');

      if (btnText) btnText.classList.remove('hidden');
      if (loadText) loadText.classList.add('hidden');
      btn.disabled = false;
    }
  };
})();
